/**
 * Lighting in 3D is critical.
 * Without lights, meshes appear black.
 *
 * We use:
 * - Ambient light → soft global illumination
 * - Directional lights → simulate sunlight
 * - Spot light → stronger highlight from above
 */
export function Lights() {
  return (
    <>
      <ambientLight intensity={0.4} />

      <directionalLight position={[300, 300, 300]} intensity={1} castShadow />

      <directionalLight position={[-300, -300, 200]} intensity={0.6} />
    </>
  );
}
